import React, { Component } from "react"
import { TextField, Dialog, FlatButton, Toggle, Chip } from "material-ui"
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton"
import ContentAddCircleOutline from "material-ui/svg-icons/content/add-circle-outline"
import strings from "../../../../../localization/strings"
import UserStatusDialog from "./UserStatusDialog"
import { IEmployeeStatus } from "../../../../../models"
import AccountStore from "../../../../../stores/AccountStore"
import * as api from "../../../../../api"
import AppStateStore from "../../../../../stores/AppStateStore"
import * as utils from "../../../../../helpers/utils"
export enum ERequiresCompletedBadges {
    YES = "yes",
    NO = "no"
}
export interface IFilter {
    Id: string;
    Name: string;
    MatchOccupation: boolean;
    MatchSpecialty: boolean;
    EmployeeStatusIds: { Status: IEmployeeStatus, SubStatus: any }[]
    RequireBagdeMatch: boolean;
    RequiresCompletedBadges: ERequiresCompletedBadges.YES | ERequiresCompletedBadges.NO
}

interface IState {
    filterData: IFilter
    openStatusDialog: boolean
    employeeStatuses: IEmployeeStatus[]
    error: boolean
    isExist: boolean
}

interface IProps {
    open: boolean
    edit: boolean
    editData: IFilter
    onClose: () => void
    saveFilter: (filter: IFilter) => void
    updateFilter: (filter: IFilter) => void
    existingFilters: IFilter[]
}

export class CandidatesFilter extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            filterData: {
                Id: "",
                Name: "",
                MatchOccupation: false,
                MatchSpecialty: false,
                RequireBagdeMatch: false,
                RequiresCompletedBadges: ERequiresCompletedBadges.YES,
                EmployeeStatusIds: []
            },
            openStatusDialog: false,
            employeeStatuses: [],
            error: false,
            isExist: false
        }
    }

    componentDidMount() {
        if (this.props.edit) this.setState({ filterData: this.props.editData })
        else {
            this.setState({
                filterData: {
                    Id: "",
                    Name: "",
                    MatchOccupation: false,
                    MatchSpecialty: false,
                    RequireBagdeMatch: false,
                    RequiresCompletedBadges: ERequiresCompletedBadges.YES,
                    EmployeeStatusIds: []
                }
            })
        }
        this.getEmployeeStatuses()
    }

    getEmployeeStatuses() {
        api.getEmployeeStatuses(AccountStore.getCurrentAccount().Id).then((response) => {
            this.setState({ employeeStatuses: response.data })
        })
    }

    handleFilterName = (event) => {
        let existFilters = []
        if (this.props.edit) existFilters = this.props.existingFilters.filter((x) => x.Id !== this.props.editData.Id)
        else existFilters = this.props.existingFilters
        this.setState({ filterData: { ...this.state.filterData, Name: event.target.value } })
        const exist = existFilters.some((x) => x.Name === event.target.value)

        if (exist) this.setState({ error: true, isExist: true })
        else this.setState({ error: false, isExist: false })
    }

    handleEmployeeStatusFilter = ({ Status, SubStatus }) => {
        const { filterData } = this.state
        const isExist = filterData.EmployeeStatusIds.find((x) => x.Status.Id === Status.Id && x.SubStatus.Id === SubStatus.Id)
        if (!isExist) {
            this.setState({ filterData: { ...filterData, EmployeeStatusIds: [...filterData.EmployeeStatusIds, { Status, SubStatus }] } })
        } else {
            AppStateStore.setProgressSnackbarContent("Already Exists")
        }
        this.setState({ openStatusDialog: false })
    }

    handleSaveFilter = () => {
        if (this.state.filterData.Name && !this.state.isExist) {
            if (!this.props.edit) this.props.saveFilter({ ...this.state.filterData, Id: utils.guid() })
            else this.props.updateFilter(this.state.filterData)
            this.setState({
                filterData: {
                    Id: "",
                    Name: "",
                    MatchOccupation: false,
                    MatchSpecialty: false,
                    RequireBagdeMatch: false,
                    RequiresCompletedBadges: ERequiresCompletedBadges.YES,
                    EmployeeStatusIds: []
                },
            })
        } else this.setState({ error: true })
    }

    render() {
        const { open, onClose } = this.props
        const { filterData, openStatusDialog, employeeStatuses, error } = this.state
        return (
            <Dialog
                open={open}
                title={strings.User_Match_Filter}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[<FlatButton label={strings.CANCEL} secondary onClick={onClose} />, <FlatButton label={strings.SAVE} primary onClick={this.handleSaveFilter} />]}
            >
                <div style={{ marginBottom: "30px" }}>
                    <TextField
                        floatingLabelText={strings.Filter_Name}
                        value={filterData.Name}
                        onChange={this.handleFilterName}
                        errorText={error && !filterData.Name ? "Field Can Not Be Empty" : null}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "50%", padding: "0px 20px" }}>
                            <Toggle
                                label={strings.Require_Occupation}
                                toggled={filterData.MatchOccupation}
                                onToggle={(event, isToggled) => this.setState({ filterData: { ...filterData, MatchOccupation: isToggled } })}
                            />
                            <Toggle
                                label={strings.Require_Speciality}
                                toggled={filterData.MatchSpecialty}
                                onToggle={(event, isToggled) => this.setState({ filterData: { ...filterData, MatchSpecialty: isToggled } })}
                            />
                        </div>
                        <div style={{ width: "50%", padding: "0px 20px" }}>
                            <Toggle
                                label={strings.Require_Badge_Match}
                                toggled={filterData.RequireBagdeMatch}
                                onToggle={(event, isToggled) => this.setState({ filterData: { ...filterData, RequireBagdeMatch: isToggled } })}
                            />
                            {filterData.RequireBagdeMatch && (
                                <RadioButtonGroup
                                    name={"RequireBagdeMatch"}
                                    defaultSelected={filterData.RequiresCompletedBadges}
                                    onChange={(e, value) => this.setState({ filterData: { ...filterData, RequiresCompletedBadges: value } })}
                                >
                                    <RadioButton value={ERequiresCompletedBadges.YES} label={strings.Require_Complete_Badge} />
                                    <RadioButton value={ERequiresCompletedBadges.NO} label={strings.Allow_Partial_Badge} />
                                </RadioButtonGroup>
                            )}
                        </div>
                    </div>
                    <div style={{ marginTop: "30px" }}>
                        <label>{strings.Match_User_Status}</label>
                        <div style={{ display: "flex" }}>
                            {filterData.EmployeeStatusIds.map((x, index) => (
                                <Chip
                                    key={`${x.Status.Id}-${index}`}
                                    style={{ margin: "5px" }}
                                    onRequestDelete={(data) => this.setState({ filterData: { ...filterData, EmployeeStatusIds: filterData.EmployeeStatusIds.filter((y, _index) => index !== _index) } })}
                                >{`${x.Status.Name} ${x.SubStatus.Name ? ": " + x.SubStatus.Name : ""}`}</Chip>
                            ))}
                            <ContentAddCircleOutline style={{ cursor: "pointer", width: "30px", height: "30px", marginTop: "6px" }} onClick={() => this.setState({ openStatusDialog: true })} />
                        </div>
                    </div>
                </div>
                {openStatusDialog && (
                    <UserStatusDialog
                        open={openStatusDialog}
                        onClose={() => this.setState({ openStatusDialog: false })}
                        onStatusSelection={this.handleEmployeeStatusFilter}
                        statuses={employeeStatuses}
                    />
                )}
            </Dialog>
        )
    }
}

// export default CandidatesFilter
